/*
 * @Author: zhang lin
 * @Date: 2022-05-25 13:48:00
 * @LastEditors: luting
 * @LastEditTime: 2022-08-18 16:01:40
 * @Description: file content
 */

import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/backup';
// 获取可用磁盘空间和配分路径
export const getDiskAndPathInfo = async () => {
  return request.get(`${basePath}/info`);
};

// 提交备份任务
export const postBackupTask = async (params: any) => {
  return request.post(`${basePath}/bak`, params);
};

// 提交还原任务
export const postRecoverTask = async (params: any) => {
  return request.post(`${basePath}/recover/info`, params);
};

// 获取备份列表
export const getBackupList = async () => {
  return request.get(`${basePath}/recover/info`);
};

// 获取日志列表
export const getLogList = async (params: any) => {
  return request.post(`${basePath}/log`, params);
};

// 获取日志详情
export const getLogDetail = async (params: any) => {
  return request.get(`${basePath}/detail`, { ...params });
};

// 获取备份/还原任务状态
export const getTaskInfo = async () => {
  return request.get(`${basePath}/busi/info`);
};

// 确认失败信息
export const confirmFail = async () => {
  return request.post(`${basePath}/busi/note`);
};

// 获取minio信息
export const getMinioInfo = async () => {
  return request.get(`${basePath}/minio`);
};

// 操作minio  开启/关闭
export const operationMinio = async (params: any) => {
  return request.post(`${basePath}/config/minio`, params);
};

// 获取时序信息
export const getTimeSequence = async () => {
  return request.get(`${basePath}/ts`);
};

// 操作时序数据同步 开启/关闭
export const operationTimeSequence = async (params: any) => {
  return request.post(`${basePath}/config/timeseq`, params);
};

// 确认设置
export const setAutoBackUpConfig = async (params: any) => {
  return request.post(`${basePath}/busi/config`, params);
};

// 获取配置
export const getAutoBackUpConfig = async () => {
  return request.get(`${basePath}/busi/config`);
};

// 自动备份开关
export const switchAutoBackUp = async (params: any) => {
  return request.post(`${basePath}/busi/onOff`, params);
};
